import R from "ramda";
import { createSlice } from "@reduxjs/toolkit";
import { useDispatch } from "react-redux";

import FaceRepository from "repositories/FaceRepository";
import { deserialize } from "utils/storeUtils";

const initialState = {
  faces: [],
  meta: null,
};

const personFacesSlice = createSlice({
  name: "personFaces",
  initialState,
  reducers: {
    loadPersonFacesSuccess(state, { payload }) {
      state.faces = deserialize(payload);
      state.meta = R.propOr(null, "meta", payload);
    },
    resetPersonFaces(state) {
      state.faces = [];
      state.meta = null;
    },
  },
});

export const { actions } = personFacesSlice;
export default personFacesSlice.reducer;

export const usePersonFacesActions = () => {
  const dispatch = useDispatch();

  const loadPersonFaces = (params) => {
    dispatch(personFacesSlice.actions.resetPersonFaces());
    return FaceRepository.index(params).then(({ data }) => {
      dispatch(personFacesSlice.actions.loadPersonFacesSuccess(data));
      return data ? deserialize(data) : null;
    });
  };

  const resetPersonFaces = () => {
    dispatch(personFacesSlice.actions.resetPersonFaces());
  };

  const removePersonFace = (personFaceId, params) => {
    return FaceRepository.partialUpdate(personFaceId, params);
  };

  const deletePersonFace = (personFaceId) => {
    return FaceRepository.delete(personFaceId);
  };

  return {
    loadPersonFaces,
    resetPersonFaces,
    removePersonFace,
    deletePersonFace,
  };
};
